export const getFileType = (path: string): string => {
  const extIndex = path.lastIndexOf('.');
  return path.slice(extIndex + 1).toLowerCase();
};
